module.exports = __webpack_public_path__ + "img/voice-thumb3.6e9f94d.jpg";